module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_gps-e7bdca6e32e4d6f365ed70f452f83b37.png";